import React, { useState } from 'react';

const OpenPayments = () => {
  const [code, setCode] = useState('');
  const [year, setYear] = useState('2023');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchCount, setSearchCount] = useState(0); // Tracks number of searches

  const maxSearches = 5;

  const searchInObject = (obj, searchTerm) => {
    for (const key in obj) {
      if (typeof obj[key] === 'string' && obj[key].toLowerCase().includes(searchTerm.toLowerCase())) {
        return true;
      }
      if (typeof obj[key] === 'object') {
        if (searchInObject(obj[key], searchTerm)) {
          return true;
        }
      }
    }
    return false;
  };

  const filterByYear = (item, selectedYear) => {
    return item.temporal && item.temporal.includes(selectedYear);
  };

  const formatData = (data) => {
    return (
      <div className="formatted-data">
        <p><strong>Title:</strong> {data.title}</p>
        <p><strong>Description:</strong> {data.description}</p>
        <p><strong>Issued:</strong> {data.issued}</p>
        <p><strong>Modified:</strong> {data.modified}</p>
        <p><strong>Publisher:</strong> {data.publisher && data.publisher.data && data.publisher.data.name ? data.publisher.data.name : 'Unknown Publisher'}</p>
        <p><strong>License:</strong> <a href={data.license} target="_blank" rel="noreferrer">{data.license}</a></p>
        {data.distribution && data.distribution[0] && data.distribution[0].data && data.distribution[0].data.downloadURL && (
          <div>
            <strong>Download Link:</strong>
            <a href={data.distribution[0].data.downloadURL} target="_blank" rel="noreferrer">
              {data.distribution[0].data.downloadURL}
            </a>
          </div>
        )}
      </div>
    );
  };

  const searchCodeDescription = async (e) => {
    e.preventDefault();

    // Prevent search if max search count is reached
    if (searchCount >= maxSearches) {
      setError(`Search limit reached. Please refresh the page to search again.`);
      return;
    }

    setLoading(true);
    setError(null);

    console.log("User entered code:", code);
    console.log("Selected year:", year);

    const apiUrl = 'https://openpaymentsdata.cms.gov/api/1/metastore/schemas/dataset/items?show-reference-ids=true';
    console.log("API URL being used:", apiUrl);

    try {
      const response = await fetch(apiUrl);
      console.log('Response status:', response.status);

      const data = await response.json();
      console.log('Received data:', data);

      if (data.length === 0) {
        throw new Error('No data returned from the API.');
      }

      const foundItem = data.find(
        item => searchInObject(item, code) && filterByYear(item, year)
      );

      console.log('Found item:', foundItem);

      if (!foundItem) {
        throw new Error(`No matches found for "${code}" in the year ${year}.`);
      }

      setResult(foundItem);

      // Increment the search count after successful search
      setSearchCount(searchCount + 1);
    } catch (error) {
      console.error('Error retrieving code description:', error);
      setError(`Error: ${error.message}`);
    } finally {
      setLoading(false);
      console.log('Finished processing.');
    }
  };

  return (
    <div className="container mx-auto max-w-2xl p-4 text-center">
      <h1 className="sm:text-4xl text-3xl font-medium title-font mb-6 text-white">
        Medical Code Lookup Tool
      </h1>
      <p className="lg:w-2/3 mx-auto leading-relaxed text-base mb-6">
        This tool allows you to search for any keyword within the Open Payments CMS dataset. 
        You can search for anything, such as medical procedure codes, recipient names, or any 
        relevant data present in the dataset. You can also filter by year (2023 or 2024). You are limited to {maxSearches} searches before refreshing the page.
      </p>

      <h2 className="text-2xl font-bold mb-4">Search the Dataset</h2>

      <form onSubmit={searchCodeDescription} className="mb-4">
        <div className="mb-2">
          <input
            type="text"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="Enter any search term"
            className="border p-2 mb-2 w-full"
            required
          />
        </div>
        <div className="mb-4">
          <label htmlFor="year" className="block text-sm font-medium mb-1">Select Year:</label>
          <select
            id="year"
            value={year}
            onChange={(e) => setYear(e.target.value)}
            className="border p-2 w-full"
          >
            <option value="2023">2023</option>
            <option value="2024">2024</option>
          </select>
        </div>
        <button
          type="submit"
          className="bg-blue-500 text-white p-2 rounded w-full"
          disabled={loading || searchCount >= maxSearches}
        >
          {loading ? 'Searching...' : 'Search'}
        </button>
      </form>

      {error && (
        <div className="mb-4 text-red-500">
          <p>{error}</p>
        </div>
      )}

      {result && (
        <div className="mb-4">
          <h3 className="text-xl font-semibold">Matched Data</h3>
          {formatData(result)}
        </div>
      )}
    </div>
  );
};

export default OpenPayments;



// WEBPACK FOOTER //
// ./src/components/OpenPayments.js